import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id CA98908E-09FA-4F06-80AF-57851BF95AD3
 * name arrow-u-left-top
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-u-left-top.svg
 * tags
 */
export const ArrowULeftTopIcon = createSvgIcon(<><path d="M20 13.5C20 17.09 17.09 20 13.5 20H6V18H13.5C16 18 18 16 18 13.5S16 9 13.5 9H7.83L10.91 12.09L9.5 13.5L4 8L9.5 2.5L10.92 3.91L7.83 7H13.5C17.09 7 20 9.91 20 13.5Z" /></>, 'ArrowULeftTopIcon');
export default ArrowULeftTopIcon